const GeneralConstants = {
  quotesRefreshMessage: 'Refreshing the Quotes',
}

export default GeneralConstants
